import React, { Component } from "react";
import { Link } from 'react-router-dom';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";

export default class CustomModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    }
  }
  render() {
    const { toggle, onSave, Child, translation } = this.props;
    return (
      <div className="col-md-12 col-sm-12 col-12">
      <Modal isOpen={true} toggle={toggle} style = {{padding: "0px", marginTop: "195px"}}>
          <div className="modal-dialog" style = {{margin: "0px"}}>
              <div className="modal-content alert alert-warning" style={{margin: "0px",lineHeight: "1.5em",borderRadius: "0px"}}>
                <div className="modal-body " style = {{margin: "0px",padding: "0px"}}>
                  <p style={{color: "red",fontSize: "1.1em",fontWeight: "bolder"}}>{translation['metrics_warning_illness_warning_a']} {Child.first_name} {translation['metrics_warning_illness_warning_b']}</p>
                  <h6>{translation['metrics_warning_illness_warning_instruction_a']} {Child.first_name} {translation['metrics_warning_illness_warning_instruction_b']}</h6>
                </div>
                <div className="modal-footer">
                  <button type="button" onclick = {toggle} className="btn" style={{borderRadius: "0px",width: "90px",color: "#000"}}>{translation['metrics_warning_cancel_button']}</button>
                  <Link to={`${process.env.PUBLIC_URL}/dashboard/feeding/feeding-practice/`}><button type="button" className="btn" style={{borderRadius: "0px",width: "90px",color: "#000"}} id="Next">{translation['metrics_warning_next_button']}</button></Link>
                </div>
              </div>
            </div>
          </Modal>
      </div>
    );
  }
}